import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-latest-stories',
  templateUrl: './home-latest-stories.component.html',
  styleUrls: ['./home-latest-stories.component.scss']
})
export class HomeLatestStoriesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
